var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoVw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.69 32.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ed008e;fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo vw") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.35,0A16.34,16.34,0,1,1,0,16.34,16.34,16.34,0,0,1,16.35,0M23.4,3.23,18.12,15h0l-.06.14a.51.51,0,0,1-.53.34H15.18a.51.51,0,0,1-.53-.34l-.06-.14h0L9.29,3.23a15,15,0,0,0-5.5,5.1l7.58,15.36h0c.07.13.19.14.25,0h0l2.81-6.3h0v0h0l.06-.14a.51.51,0,0,1,.53-.34h2.43a.51.51,0,0,1,.53.34l.06.14h0v0h0L21,23.69h0c.06.14.19.14.26,0h0L28.9,8.33a15,15,0,0,0-5.5-5.1m-7.05,9.89c.05,0,.1,0,.14-.13h.06L21.27,2.29a15,15,0,0,0-9.84,0l4.71,10.56h.06c0,.09.09.13.14.13m13.87-2.19L21.56,28.47h0v0h0l0,.09a.45.45,0,0,1-.83,0l0-.09h0l-4-9h0l0-.08c0-.09-.09-.13-.14-.13s-.11,0-.14.13l0,.08h0l-4,9h0l0,.09a.45.45,0,0,1-.83,0l0-.09h0v0h0L2.47,10.92a14.89,14.89,0,1,0,27.75,0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVw);
export default __webpack_public_path__ + "static/media/logo-vw.3ad66be7f8b06a5b1289b3ca8e523bb8.svg";
export { ForwardRef as ReactComponent };